import { render, staticRenderFns } from "./posUser.vue?vue&type=template&id=19896236&scoped=true&"
import script from "./posUser.vue?vue&type=script&lang=js&"
export * from "./posUser.vue?vue&type=script&lang=js&"
import style0 from "./posUser.vue?vue&type=style&index=0&id=19896236&prod&scoped=true&lang=css&"
import style1 from "./posUser.vue?vue&type=style&index=1&id=19896236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19896236",
  null
  
)

export default component.exports